import {
  faPeopleGroup,
  faMessagesQuestion,
  faSquarePollHorizontal,
} from "@fortawesome/pro-light-svg-icons";
import { t } from "i18next";
import SignedInUserDto from "../../types/dtos/users/SignedInUserDto";
import SubNavItem from "../../types/nav/SubNavItem";
import AppRoutes from "../AppRoutes";
import taskTypeIconHelper from "../../helpers/taskTypeIconHelper";
import { userDetailsHelper } from "../../helpers";

const YourPeopleSubNavItems = (loggedInUser: SignedInUserDto): SubNavItem[] => {
  const output: SubNavItem[] = [];

  const managerBadgeNumber =
    userDetailsHelper.getManagerUpdateCount(loggedInUser);

  // The main manager dashboard
  output.push({
    title: "Nav.LargeScreen.ManagerDashboard.Home",
    translateTitle: true,
    url: AppRoutes.yourPeople.root,
    badgeCount: managerBadgeNumber > 0 ? managerBadgeNumber : undefined,
    icon: faPeopleGroup,
  });

  // Addition of 'Conversations'
  output.push({
    title: t("Nav.LargeScreen.ManagerDashboard.Conversations"),
    translateTitle: false,
    url: AppRoutes.yourPeople.conversations.path,
    badgeCount: undefined,
    icon: faMessagesQuestion,
  });

  if (loggedInUser.client.usesPulseChecks) {
    // Addition of 'Pulse Checks'
    output.push({
      title: t("Nav.LargeScreen.ManagerDashboard.PulseChecks"),
      translateTitle: false,
      url: AppRoutes.yourPeople.pulseChecks,
      badgeCount: undefined,
      icon: faSquarePollHorizontal,
    });
  }

  // Addition of AdvancedTaskTypes
  loggedInUser.client.taskTypes.forEach((clientTaskType) => {
    const taskTypeHighlights = loggedInUser.highlightedTasks.find(
      (x) => x.taskTypeId === clientTaskType.id
    );
    output.push({
      title: clientTaskType.shortTitleTranslationKeyIdentifier,
      translateTitle: true,
      url: AppRoutes.yourPeople.tasks.generateRoute(clientTaskType.id),
      badgeCount: taskTypeHighlights?.managerTaskIds
        ? taskTypeHighlights.managerTaskIds.length
        : undefined,
      icon: taskTypeIconHelper.getTaskTypeIcon(
        clientTaskType.iconType,
        "LIGHT"
      ),
    });
  });

  return output;
};

export default YourPeopleSubNavItems;
